import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { gameCoinConfig } from "@/api/data";
export var gameCoin = {
  namespaced: true,
  state: {
    isInit: 0,
    coinKv: {}
  },
  mutations: {
    setCoinKv: function setCoinKv(state, coinMap) {
      state.isInit = 1;
      state.coinKv = coinMap;
    }
  },
  actions: {
    getCoin: function getCoin(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, coinMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return gameCoinConfig();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                coinMap = {};
                res.data.forEach(function (val) {
                  coinMap[val.id] = val.desc;
                });
                // dictionaryMap[res.data.resysDictionary.type] = dict
                commit("setCoinKv", coinMap);
                // return state.dictionaryMap[type]
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    coinMap: function coinMap(state) {
      return state.coinKv;
    }
  }
};